// Copyright (c) 2020 Deere & Company

import AdvanceSearchAccordion from './advance-search-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    search: state.rga.search,
    shared: state.rga.shared
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AdvanceSearchAccordion);



// WEBPACK FOOTER //
// ./src/rga/search/components/advance-search-rga/index.js